export const presetColors = [
  {
    name: "red",
    FG: [
      "#ffebee",
      "#ffcdd2",
      "#ef9a9a",
      "#e57373",
      "#ef5350",
      "#f44336",
      "#e53935",
      "#d32f2f",
      "#c62828",
      "#b71c1c",
    ],
    BG: ["#ff8a80", "#ff5252", "#ff1744", "#d50000"],
  },

  {
    name: "neon pink",
    FG: [
      "#fce4ec",
      "#f8bbd0",
      "#f48fb1",
      "#f06292",
      "#ec407a",
      "#e91e63",
      "#d81b60",
      "#c2185b",
      "#ad1457",
      "#880e4f",
    ],
    BG: ["#ff80ab", "#ff4081", "#f50057", "#c51162"],
  },

  {
    name: "purple",
    FG: [
      "#f3e5f5",
      "#e1bee7",
      "#ce93d8",
      "#ba68c8",
      "#ab47bc",
      "#9c27b0",
      "#8e24aa",
      "#7b1fa2",
      "#6a1b9a",
      "#4a148c",
    ],
    BG: ["#ea80fc", "#e040fb", "#d500f9", "#aa00ff"],
  },

  {
    name: "deep purple",
    FG: [
      "#ede7f6",
      "#d1c4e9",
      "#b39ddb",
      "#9575cd",
      "#7e57c2",
      "#673ab7",
      "#5e35b1",
      "#512da8",
      "#4527a0",
      "#311b92",
    ],
    BG: ["#b388ff", "#7c4dff", "#651fff", "#6200ea"],
  },

  {
    name: "indigo",
    FG: [
      "#e8eaf6",
      "#c5cae9",
      "#9fa8da",
      "#7986cb",
      "#5c6bc0",
      "#3f51b5",
      "#3949ab",
      "#303f9f",
      "#283593",
      "#1a237e",
    ],
    BG: ["#8c9eff", "#536dfe", "#3d5afe", "#304ffe"],
  },

  {
    name: "blue",
    FG: [
      "#e3f2fd",
      "#bbdefb",
      "#90caf9",
      "#64b5f6",
      "#42a5f5",
      "#2196f3",
      "#1e88e5",
      "#1976d2",
      "#1565c0",
      "#0d47a1",
    ],
    BG: ["#82b1ff", "#448aff", "#2979ff", "#2962ff"],
  },

  {
    name: "light blue",
    FG: [
      "#e1f5fe",
      "#b3e5fc",
      "#81d4fa",
      "#4fc3f7",
      "#29b6f6",
      "#03a9f4",
      "#039be5",
      "#0288d1",
      "#0277bd",
      "#01579b",
    ],
    BG: ["#80d8ff", "#40c4ff", "#00b0ff", "#0091ea"],
  },

  {
    name: "cyan",
    FG: [
      "#e0f7fa",
      "#b2ebf2",
      "#80deea",
      "#4dd0e1",
      "#26c6da",
      "#00bcd4",
      "#00acc1",
      "#0097a7",
      "#00838f",
      "#006064",
    ],
    BG: ["#84ffff", "#18ffff", "#00e5ff", "#00b8d4"],
  },

  {
    name: "viridity",
    FG: [
      "#e0f2f1",
      "#b2dfdb",
      "#80cbc4",
      "#4db6ac",
      "#26a69a",
      "#009688",
      "#00897b",
      "#00796b",
      "#00695c",
      "#004d40",
    ],
    BG: ["#a7ffeb", "#64ffda", "#1de9b6", "#00bfa5"],
  },

  {
    name: "green",
    FG: [
      "#e8f5e9",
      "#c8e6c9",
      "#a5d6a7",
      "#81c784",
      "#66bb6a",
      "#4caf50",
      "#43a047",
      "#388e3c",
      "#2e7d32",
      "#1b5e20",
    ],
    BG: ["#b9f6ca", "#69f0ae", "#00e676", "#00c853"],
  },

  {
    name: "lightgreen",
    FG: [
      "#f1f8e9",
      "#dcedc8",
      "#c5e1a5",
      "#aed581",
      "#9ccc65",
      "#8bc34a",
      "#7cb342",
      "#689f38",
      "#558b2f",
      "#33691e",
    ],
    BG: ["#ccff90", "#b2ff59", "#76ff03", "#64dd17"],
  },

  {
    name: "limestone",
    FG: [
      "#f9fbe7",
      "#f0f4c3",
      "#e6ee9c",
      "#dce775",
      "#d4e157",
      "#cddc39",
      "#c0ca33",
      "#afb42b",
      "#9e9d24",
      "#827717",
    ],
    BG: ["#f4ff81", "#eeff41", "#c6ff00", "#aeea00"],
  },

  {
    name: "AgBr",
    FG: [
      "#fffde7",
      "#fff9c4",
      "#fff59d",
      "#fff176",
      "#ffee58",
      "#ffeb3b",
      "#fdd835",
      "#fbc02d",
      "#f9a825",
      "#f57f17",
    ],
    BG: ["#ffff8d", "#ffff00", "#ffea00", "#ffd600"],
  },

  {
    name: "persimmon",
    FG: [
      "#fff8e1",
      "#ffecb3",
      "#ffe082",
      "#ffd54f",
      "#ffca28",
      "#ffc107",
      "#ffb300",
      "#ffa000",
      "#ff8f00",
      "#ff6f00",
    ],
    BG: ["#ffe57f", "#ffd740", "#ffc400", "#ffab00"],
  },

  {
    name: "tangerine",
    FG: [
      "#fff3e0",
      "#ffe0b2",
      "#ffcc80",
      "#ffb74d",
      "#ffa726",
      "#ff9800",
      "#fb8c00",
      "#f57c00",
      "#ef6c00",
      "#e65100",
    ],
    BG: ["#ffd180", "#ffab40", "#ff9100", "#ff6d00"],
  },

  {
    name: "deep orange",
    FG: [
      "#fbe9e7",
      "#ffccbc",
      "#ffab91",
      "#ff8a65",
      "#ff7043",
      "#ff5722",
      "#f4511e",
      "#e64a19",
      "#d84315",
      "#bf360c", // Material colors
    ],
    BG: ["#541907", "#541907", "#540722", "#3b0518"],
  },

  {
    name: "rose",
    FG: [
      "#fff1f2",
      "#ffe4e6",
      "#fecdd3",
      "#fda4af",
      "#fb7185",
      "#f43f5e",
      "#e11d48",
      "#be123c",
      "#9f1239",
      "#881337",
    ],
    BG: ["#6f0d3c", "#9f2a12", "#99129f", "#6b0d6f"],
  },

  {
    name: "pink",
    FG: [
      "#fdf2f8",
      "#fce7f3",
      "#fbcfe8",
      "#f9a8d4",
      "#f472b6",
      "#ec4899",
      "#db2777",
      "#be185d",
      "#9d174d",
      "#831843",
    ],
    BG: ["#5c113f", "#832018", "#6d1883", "#4d115c"],
  },

  {
    name: "fuchsia",
    FG: [
      "#fdf4ff",
      "#fae8ff",
      "#f5d0fe",
      "#f0abfc",
      "#e879f9",
      "#d946ef",
      "#c026d3",
      "#a21caf",
      "#86198f",
      "#701a75",
    ],
    BG: ["#4f147a", "#af1c94", "#4223af", "#2e197a"],
  },

  {
    name: "lavender",
    FG: [
      "#faf5ff",
      "#f3e8ff",
      "#e9d5ff",
      "#d8b4fe",
      "#c084fc",
      "#a855f7",
      "#9333ea",
      "#7e22ce",
      "#6b21a8",
      "#581c87",
    ],
    BG: ["#391252", "#751a62", "#341d75", "#251452"],
  },

  {
    name: "violet",
    FG: [
      "#f5f3ff",
      "#ede9fe",
      "#ddd6fe",
      "#c4b5fd",
      "#a78bfa",
      "#8b5cf6",
      "#7c3aed",
      "#6d28d9",
      "#5b21b6",
      "#4c1d95",
    ],
    BG: ["#291968", "#611d95", "#1d4995", "#143368"],
  },

  {
    name: "indigo light",
    FG: [
      "#eef2ff",
      "#e0e7ff",
      "#c7d2fe",
      "#a5b4fc",
      "#818cf8",
      "#6366f1",
      "#4f46e5",
      "#4338ca",
      "#3730a3",
      "#312e81",
    ],
    BG: ["#212e5a", "#4b2e81", "#2e7c81", "#2e7c81"],
  },

  {
    name: "ocean",
    FG: [
      "#eff6ff",
      "#dbeafe",
      "#bfdbfe",
      "#93c5fd",
      "#60a5fa",
      "#3b82f6",
      "#2563eb",
      "#1d4ed8",
      "#1e40af",
      "#1e3a8a",
    ],
    BG: ["#15457a", "#392daf", "#392daf", "#157a5a"],
  },

  {
    name: "sky",
    FG: [
      "#f0f9ff",
      "#e0f2fe",
      "#bae6fd",
      "#7dd3fc",
      "#38bdf8",
      "#0ea5e9",
      "#0284c7",
      "#0369a1",
      "#075985",
      "#0c4a6e",
    ],
    BG: ["#083e4d", "#12206e", "#0c6e25", "#084d1a"],
  },

  {
    name: "aqua",
    FG: [
      "#ecfeff",
      "#cffafe",
      "#a5f3fc",
      "#67e8f9",
      "#22d3ee",
      "#06b6d4",
      "#0891b2",
      "#0e7490",
      "#155e75",
      "#164e63",
    ],
    BG: ["#0d5759", "#1c5055", "#194b51", "#084671"],
  },

  {
    name: "teal",
    FG: [
      "#f0fdfa",
      "#ccfbf1",
      "#99f6e4",
      "#5eead4",
      "#2dd4bf",
      "#14b8a6",
      "#0d9488",
      "#0f766e",
      "#115e59",
      "#134e4a",
    ],
    BG: ["#0c4242", "#cbffff", "#97ffff", "#115e59"],
  },

  {
    name: "emerald",
    FG: [
      "#ecfdf5",
      "#d1fae5",
      "#a7f3d0",
      "#6ee7b7",
      "#34d399",
      "#10b981",
      "#059669",
      "#047857",
      "#065f46",
      "#064e3b",
    ],
    BG: ["#04433a", "#0c5f06", "#084304", "#062f03"],
  },

  {
    name: "leaf",
    FG: [
      "#f0fdf4",
      "#dcfce7",
      "#bbf7d0",
      "#86efac",
      "#4ade80",
      "#22c55e",
      "#16a34a",
      "#15803d",
      "#166534",
      "#14532d",
    ],
    BG: ["#cfffed", "#9effdb", "#e7fffb", "#e7fffb"],
  },

  {
    name: "lime",
    FG: [
      "#f7fee7",
      "#ecfccb",
      "#d9f99d",
      "#bef264",
      "#a3e635",
      "#84cc16",
      "#65a30d",
      "#4d7c0f",
      "#3f6212",
      "#365314",
    ],
    BG: ["#31450d", "#176212", "#626012", "#45430d"],
  },

  {
    name: "yellow",
    FG: [
      "#fefce8",
      "#fef9c3",
      "#fef08a",
      "#fde047",
      "#facc15",
      "#eab308",
      "#ca8a04",
      "#a16207",
      "#854d0e",
      "#713f12",
    ],
    BG: ["#4f320d", "#715a12", "#713112", "#4f220d"],
  },

  {
    name: "amber",
    FG: [
      "#fffbeb",
      "#fef3c7",
      "#fde68a",
      "#fcd34d",
      "#fbbf24",
      "#f59e0b",
      "#d97706",
      "#b45309",
      "#92400e",
      "#78350f",
    ],
    BG: ["#ffdfc7", "#ffdfc7", "#ffeec7", "#b3938b"],
  },

  {
    name: "orange",
    FG: [
      "#fff7ed",
      "#ffedd5",
      "#fed7aa",
      "#fdba74",
      "#fb923c",
      "#f97316",
      "#ea580c",
      "#c2410c",
      "#9a3412",
      "#7c2d12",
    ],
    BG: ["#ff9e80", "#ff6e40", "#ff3d00", "#dd2c00"],
  },

  {
    name: "cherry",
    FG: [
      "#fef2f2",
      "#fee2e2",
      "#fecaca",
      "#fca5a5",
      "#f87171",
      "#ef4444",
      "#dc2626",
      "#b91c1c",
      "#991b1b",
      "#7f1d1d",
    ],
    BG: ["#ff9e80", "#ff6e40", "#ff3d00", "#dd2c00"],
  },

  {
    name: "stone",
    FG: [
      "#fafaf9",
      "#f5f5f4",
      "#e7e5e4",
      "#d6d3d1",
      "#a8a29e",
      "#78716c",
      "#57534e",
      "#44403c",
      "#292524",
      "#1c1917",
    ],
    BG: ["#fafaf9", "#a8a29e", "#57534e", "#1c1917"],
  },

  {
    name: "neutral",
    FG: [
      "#fafafa",
      "#f5f5f5",
      "#e5e5e5",
      "#d4d4d4",
      "#a3a3a3",
      "#737373",
      "#525252",
      "#404040",
      "#262626",
      "#171717",
    ],
    BG: ["#1b1b1b", "#000000", "#333333", "#111111"],
  },

  {
    name: "zinc",
    FG: [
      "#fafafa",
      "#f4f4f5",
      "#e4e4e7",
      "#d4d4d8",
      "#a1a1aa",
      "#71717a",
      "#52525b",
      "#3f3f46",
      "#27272a",
      "#18181b",
    ],
    BG: ["#1b1b1a", "#00000A", "#33333a", "#11111a"],
  },

  {
    name: "gray",
    FG: [
      "#f9fafb",
      "#f3f4f6",
      "#e5e7eb",
      "#d1d5db",
      "#9ca3af",
      "#6b7280",
      "#4b5563",
      "#374151",
      "#1f2937",
      "#111827",
    ],
    BG: ["#f9fafb", "#f3f4f6", "#e5e7eb", "#d1d5db"],
  },

  {
    name: "slate",
    FG: [
      "#f8fafc",
      "#f1f5f9",
      "#e2e8f0",
      "#cbd5e1",
      "#94a3b8",
      "#64748b",
      "#475569",
      "#334155",
      "#1e293b",
      "#0f172a",
    ],
    BG: ["#475569", "#334155", "#1e293b", "#0f172a"],
  },
];
export const hex2rgba = (
  hex: {
    match: (arg0: RegExp) => {
      (): any;
      new (): any;
      map: { (arg0: (x: any) => number): [any, any, any]; new (): any };
    };
  },
  alpha = 1
) => {
  const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};
export function increase_brightness(hex: string, percent: number) {
  // strip the leading # if it's there
  hex = hex.replace(/^\s*#|\s*$/g, "");

  // convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
  if (hex.length == 3) {
    hex = hex.replace(/(.)/g, "$1$1");
  }

  var r = parseInt(hex.substr(0, 2), 16),
    g = parseInt(hex.substr(2, 2), 16),
    b = parseInt(hex.substr(4, 2), 16);

  return (
    "#" +
    (0 | ((1 << 8) + r + ((256 - r) * percent) / 100)).toString(16).substr(1) +
    (0 | ((1 << 8) + g + ((256 - g) * percent) / 100)).toString(16).substr(1) +
    (0 | ((1 << 8) + b + ((256 - b) * percent) / 100)).toString(16).substr(1)
  );
}
